"use client";

import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { motion } from "motion/react";
import React from "react";
import MotionHighlight from "@/components/effects/MotionHighlight";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuItemProps } from "../types";

function DropdownMenuItem({
  inset,
  disabled,
  variant = "default",
  className,
  children,
  ...props
}: DropdownMenuItemProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <MotionHighlight.Item
      activeClassName={
        variant === "default"
          ? "bg-accent"
          : "bg-destructive/10 dark:bg-destructive/20"
      }
      disabled={disabled}
    >
      <DropdownMenuPrimitive.Item {...native} asChild disabled={disabled}>
        <motion.div
          data-slot="dropdown-menu-item"
          data-inset={inset}
          data-variant={variant}
          data-disabled={disabled}
          whileTap={{ scale: 0.95 }}
          className={cn(
            "[&:not([data-highlight])]:focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive [&:not([data-highlight])]:data-[variant=destructive]:focus:bg-destructive/10 dark:[&:not([data-highlight])]:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:!text-destructive [&_svg:not([class*='text-'])]:text-muted-foreground relative z-[1] flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus-visible:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
            inset && "pl-8",
            className,
            classes,
          )}
        >
          {children}
        </motion.div>
      </DropdownMenuPrimitive.Item>
    </MotionHighlight.Item>
  );
}

DropdownMenuItem.displayName = "DropdownMenu.Item";

export default DropdownMenuItem;
